export const FUNCTION_SETTING = {
    internalQACounterSettings: {
        value: false
    },
    externalServiceDeskSettings: {
        group: {
            deskService: {
                value: false
            },
            publicWebForm: {
                value: false
            }
        }
    },
    emailResponseFunction: {
        value: false
    },
    knowledgeFunction: {
        group: {
            knowledgeService: {
                value: false
            },
            publicService: {
                value: false
            },
            knowledgeBot: {
                value: false
            },
            convertPDF: {
                value: false
            },
            synonymSearch: {
                value: false
            },
            batchCommandService: {
                value: false
            }
        }
    },
    chatAI: {
        value: false
    },
    lincenseKeyPermission: {
        value: false
    },
    aiAuto: {
        value: false
    },
    sdAuto: {
        value: false
    },
    telephoneAgent: {
        value: false
    },
    fileTranslation: {
        value: false
    },
    kBoard: {
        value: false
    },
    externalWebAPI: {
        value: false
    },
    mcpServer: {
        value: false
    },
    localMcpEnabled: {
        value: {}
    },
    multiLanguage: {
        value: false
    },
    taskManagement: {
        value: false
    },
    advancedOptionSettings: {
        value: false
    },
    logAnalysis: {
        value: false
    },
    ipRestriction : {
        value: false
    },
    multiAuth: {
        value: false
    }
};

export const BASIC_SETTING = {
    numberOfTickets: {
        type: 'number',
        value: '',
        unit: 'setPersion',
        error: '',
        rules: [
            { name: 'maxLength', value: 8 },
            { name: 'minValue', value: 1 },
            { name: 'isNumber'}
        ],
    },
    numberOfKnowledges: {
        type: 'number',
        value: '',
        unit: 'setPersion',
        error: '',
        rules: [
            { name: 'maxLength', value: 8 },
            { name: 'minValue', value: 0 },
            { name: 'isNumber'}
        ],
    },
    numberOfFormat: {
        type: 'number',
        value: '',
        unit: 'setCorp',
        error: '',
        rules: [
            { name: 'maxLength', value: 8 },
            { name: 'minValue', value: 0 },
            { name: 'isNumber'}
        ],
    },
    numberOfQACounters: {
        type: 'number',
        value: '',
        unit: 'setCorp',
        error: '',
        rules: [
            { name: 'maxLength', value: 8 },
            { name: 'minValue', value: 0 },
            { name: 'isNumber'}
        ],
    },
    numberOfSupportedCounters: {
        type: 'number',
        value: '',
        unit: 'setCorp',
        error: '',
        rules: [
            { name: 'maxLength', value: 8 },
            { name: 'minValue', value: 0 },
            { name: 'isNumber'}
        ],
    },
    numberOfGeneralProjects: {
        type: 'number',
        value: '',
        unit: 'setCorp',
        error: '',
        rules: [
            { name: 'maxLength', value: 8 },
            { name: 'minValue', value: 0 },
            { name: 'isNumber'}
        ],
    },
    numberOfInternalCustomers: {
        type: 'number',
        value: '',
        unit: 'setCorpPersion',
        error: '',
        rules: [
            { name: 'maxLength', value: 8 },
            { name: 'minValue', value: 0 },
            { name: 'isNumber'}
        ],
    },
    numberOfB2C: {
        type: 'number',
        value: '',
        unit: 'setCorpPersion',
        error: '',
        rules: [
            { name: 'maxLength', value: 8 },
            { name: 'minValue', value: 0 },
            { name: 'isNumber'}
        ],
    },
    storageVolume: {
        type: 'decimal',
        value: '',
        unit: 'gbPersion',
        error: '',
        rules: [
            { name: 'isDecimal'},
        ],
    },
    generalUserFee: {
        type: 'number',
        value: '',
        unit: 'price',
        error: '',
        rules: [
            { name: 'maxLength', value: 38 },
            { name: 'minValue', value: 0 },
            { name: 'isNumber'}
        ],
    },
    basicCharge: {
        type: 'number',
        value: '',
        unit: 'price',
        error: '',
        rules: [
            { name: 'maxLength', value: 38 },
            { name: 'minValue', value: 0 },
            { name: 'isNumber'}
        ],
    },
    numberOfExWebAPI: {
        number: {
            type: 'number',
            value: '',
            unit: 'numberCallPerMonth',
            error: '',
            rules: [
                { name: 'maxLength', value: 8 },
                { name: 'minValue', value: 1 },
                { name: 'isNumber'}
            ],
        },
        isUseUnlimited: {
            value: true
        }
    }
};

export const ADVANCED_SETTING = {
    numberOfAdditionalTickets: {
        quantity: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 8 },
                { name: 'minValue', value: 1 },
                { name: 'isNumber'}
            ],
        },
        price: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 38 },
                { name: 'minValue', value: 0 },
                { name: 'isNumber'}
            ],
        }
    },
    numberOfAdditionalKnowledge: {
        quantity: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 8 },
                { name: 'minValue', value: 0 },
                { name: 'isNumber'}
            ],
        },
        price: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 38 },
                { name: 'minValue', value: 0 },
                { name: 'isNumber'}
            ],
        }
    },
    numberOfAdditionalStorages: {
        quantity: {
            type: 'decimal',
            value: '',
            error: '',
            rules: [
                { name: 'isDecimal'},
            ],
        },
        price: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 38 },
                { name: 'minValue', value: 0 },
                { name: 'isNumber'}
            ],
        }
    },
    numberOfAdditionalQACounter: {
        quantity: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 8 },
                { name: 'minValue', value: 0 },
                { name: 'isNumber'}
            ],
        },
        price: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 38 },
                { name: 'minValue', value: 0 },
                { name: 'isNumber'}
            ],
        }
    },
    numberOfAdditionalSupportedCounter: {
        quantity: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 8 },
                { name: 'minValue', value: 0 },
                { name: 'isNumber'}
            ],
        },
        price: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 38 },
                { name: 'minValue', value: 0 },
                { name: 'isNumber'}
            ],
        }
    },
    numberOfAdditionalExWebAPI: {
        quantity: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 8 },
                { name: 'minValue', value: 0 },
                { name: 'isNumber'}
            ],
        },
        price: {
            type: 'number',
            value: '',
            error: '',
            rules: [
                { name: 'maxLength', value: 38 },
                { name: 'minValue', value: 0 },
                { name: 'isNumber'}
            ],
        }
    }
};